import React, { Component } from "react";

class PanelContent extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { className, children } = this.props;

		const style = ["panel-content-component", className].join(" ");

		return <div className={style}>{children}</div>;
	}
}

export default PanelContent;
